import React, { useContext } from 'react'
import styled from '@emotion/styled'

import { Layout, SimpleHeader, SiteConfigContext } from '@jelly/components'

const Container = styled.main`
	line-height: 1.5rem;
	margin: 50px auto 100px;
	padding: 0 20px;

	${({ theme }) => theme.MQ.M} {
		max-width: ${({ theme }) => theme.BREAKPOINTS['M']}px;
	}

	strong {
		${({ theme }) => theme.fonts.primarySemiBold}
	}

	a {
		color: ${({ theme }) => theme.colors.contentLink};
		&:hover {
			color: ${({ theme }) => theme.colors.contentLinkHover};
		}
	}

	h4 {
		margin-top: 2rem;
	}
`

export const DefaultMarkdown = ({ children, pageContext: { frontmatter } }) => {
	const {
		siteConstants: { META_DATA, SITE_HOST },
	} = useContext(SiteConfigContext)

	return (
		<Layout
			inverseLinkColors={true}
			meta={{
				...META_DATA,
				title: `${frontmatter.title} - ${META_DATA.applicationName}`,
				canonical: `${SITE_HOST}/${frontmatter.breadcrumbs.primary.slug}/`,
			}}
		>
			<SimpleHeader
				breadcrumbs={frontmatter.breadcrumbs}
				canonical={`${SITE_HOST}/${frontmatter.breadcrumbs.primary.slug}/`}
				subTitle={frontmatter.subTitle}
				title={frontmatter.title}
				shouldShowLeaderboardAds={false}
			/>

			<Container>{children}</Container>
		</Layout>
	)
}
